/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tables: NonNullable<unknown> }} Err_Tournament_Tables_Not_FinishedInputs */



/**
* | output |
* | --- |
* | "Tables {tables} not finished yet" |
*
* @param {Err_Tournament_Tables_Not_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_tables_not_finished = /** @type {((inputs: Err_Tournament_Tables_Not_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Tables_Not_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tables ${i?.tables} pas encore terminées`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Las mesas ${i?.tables} aún no han finalizado`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Mesas ${i?.tables} ainda não finalizadas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`I tavoli ${i?.tables} non sono ancora terminati`)
	return /** @type {LocalizedString} */ (`Tables ${i?.tables} not finished yet`)
});